import { useEffect } from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import { Stack } from '@chakra-ui/react'
import {
  authSelectors,
  setUserSectionPage,
  usersSelectors
} from 'store'
import {
  FORGOT_PASSWORD,
  PENDING,
  SIGN_IN,
  SIGN_UP,
  VERIFY_LINK_PAGE
} from 'utils/constants'

import { ForgotPassword } from 'components/Auth/ForgotPassword'
import { SignIn } from 'components/Auth/SignIn'
import { SignUp } from 'components/Auth/SignUp'
import { VerifyLinkPage } from 'components/Auth/VerifyLinkPage'

import { Links } from './Links'

export const Auth = ({ pageName }) => {
  const dispatch = useDispatch()

  const { getUserStatus } = useSelector(usersSelectors)

  const {
    signInStatus,
    signUpStatus,
    forgotPasswordStatus,
    verifyPageText
  } = useSelector(authSelectors)

  const selectPage = () => {
    switch (pageName) {
    case SIGN_IN:
      return (
        <SignIn
          isLoading={signInStatus === PENDING || getUserStatus === PENDING}
          setUserSectionPage={setUserSectionPage}
        />
      )
    case SIGN_UP:
      return (
        <SignUp
          isLoading={signUpStatus === PENDING}
          setUserSectionPage={setUserSectionPage}
        />
      )
    case VERIFY_LINK_PAGE:
      return (
        <VerifyLinkPage
          verifyPageText={verifyPageText}
          setUserSectionPage={setUserSectionPage}
        />
      )
    case FORGOT_PASSWORD:
      return <ForgotPassword isLoading={forgotPasswordStatus === PENDING} />
    default:
      return null
    }
  }

  useEffect(() => {
    dispatch(setUserSectionPage(SIGN_IN))
  }, [])

  return (
    <Stack
      height="100%"
      justifyContent="space-between"
      padding="24px 65px"
    >
      {selectPage()}
      <Links />
    </Stack>
  )
}
